import { render, staticRenderFns } from "./BooksTable.vue?vue&type=template&id=c327406c"
import script from "./BooksTable.vue?vue&type=script&lang=js"
export * from "./BooksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports